import React, { useContext, useEffect, useState } from "react";
import {Routes, Route, useLocation} from "react-router-dom";
import { useParams } from "react-router";
import Listing from "../../../tools/table/Listing";
import FragmentationDevReq from "./FragmentationDevReq";
import StateDevelopmentRequest from "../../../load/StateDevelopmentRequest";
import DevelopmentRequestController from "../../../../stories/_ticket/DevelopmentRequests/DevelopmentRequestController";
import SessionContext from "../../../../context/SessionContext";
import ListingContext from "../../../../context/ListingContext";
import FilterContext from "../../../../context/FilterContext";
import AppContext from "../../../../context/AppContext";

const DevelopmentRequest = () => {
    const item = "developmentRequests";
    const itemClass = "Demande d'évolution";
    const titleWindow = "Demandes d'évolutions";
    const emptyList = "Aucune demande d'évolution";
    const params = useParams();
    const location = useLocation();
    const { handleLogout } = useContext(SessionContext);
    const { filters } = useContext(FilterContext);
    const { getDatasPopup, statePopup, subStatePopup, setEvent } = useContext(AppContext);
    const [ pageSelect, setPageSelect ] = useState(1);
    const [ loading, setLoading ] = useState(false);
    const [ list, setList ] = useState([]);
    const [ pagination, setPagination ] = useState(null);
    const [ perPage, setPerPage ] = useState(25);
    const [ sortingName, setSortingName ] = useState("number");
    const [ sortingValue, setSortingValue ] = useState("asc");

    const getDevelopmentRequests = (pPage, pPerPage, pSortingName, pSortingValue) => {
        setLoading(true);

        const controller = new DevelopmentRequestController();
        controller._callback = callbackGetDevelopmentRequests;
        controller.index(filters.state, filters.search, pPage, pPerPage, pSortingName, pSortingValue, "");
    }
    const callbackGetDevelopmentRequests = (listDevelopmentRequests, error, pagination, status) => {
        setLoading(false);

        switch (status) {
            case 200:
                setList(listDevelopmentRequests);
                setPagination(pagination !== undefined ? pagination : null );
                break;
            case 401:
                handleLogout();
                break;
            default:
                setEvent({
					type: "error",
					text: "Impossible de récupérer la liste des demandes d'évolution"
				});
                break;
        }
    }
    const updatePageSelect = page => {
        setPageSelect(page);
    }
    const handleRefresh = () => {
        getDevelopmentRequests(pageSelect, perPage, sortingName, sortingValue);
    }

    const model = [
        {
            "class": "id",
            "sortingParam": "number",
            "title": "#",
            "attributes": ["number"],
            "type": "text",
            "link": "{id}"
        },
        {
            "class": "state",
            "sortingParam": "state",
            "title": "état",
            "attributes": ["state"],
            "type": "state"
        },
        {
            "class": "name",
            "sortingParam": "title",
            "title": "Titre",
            "attributes": ["title"],
            "type": "text",
            "link": "{id}"
        },
        {
            "class": "dateTime",
            "sortingParam": "",
            "title": "Date",
            "attributes": ["created_at", "creatorName"],
            "type": "fromNow"
        }
    ];

    useEffect(() => {
        document.title = titleWindow;
    }, []);
    useEffect(() => {
		if (params.currentPage !== undefined)
			setPageSelect(params.currentPage)
    }, [params]);
    useEffect(() => {
        handleRefresh();
    }, [perPage, pageSelect, sortingName, sortingValue, filters]);

    return (
        <ListingContext.Provider value={{page: pageSelect}}>
			<FragmentationDevReq />
            <Listing
                item={ item }
                itemClass={ itemClass }
                titleNbItems={ itemClass }
                emptyList={ emptyList }
                model={ model }
                pageSelect={ pageSelect }
                updatePageSelect={ updatePageSelect }
                list={ list }
                loading={ loading }
                pagination={ pagination }
                checkable={ false }
                openable={ true }
                preview={ false }
                setPerPage={ setPerPage }
                sortingName={ sortingName }
                sortingValue={ sortingValue }
                setSortingName={ setSortingName }
                setSortingValue={ setSortingValue }
            />
            <Routes>
                <Route index element={<StateDevelopmentRequest state={"hidden"} />} />
                <Route exact path="new" element={<StateDevelopmentRequest state={"loading"} subState={"new"} loadingText={"Chargement..."} loadingIcon={true} />} />
				<Route exact path=":id" element={<StateDevelopmentRequest state={"loading"} subState={"update"} loadingText={"Ouverture de la demande d'évolution..."} loadingIcon={true} />} />
            </Routes>
        </ListingContext.Provider>
    )
}

export default DevelopmentRequest;
